"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateUser = exports.getUserById = exports.getUserByMobile = exports.getUserBundleInfo = exports.getAuthorNumbersByUserId = void 0;
var tslib_1 = require("tslib");
var graphql_tag_1 = require("graphql-tag");
function getAuthorNumbersByUserId(_a) {
    var userId = _a.userId;
    var variables = {
        where: {
            id: userId,
        },
    };
    return {
        variables: variables,
        query: (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n      query GetProperties($where: UserWhereUniqueInput!) {\n        user(where: $where) {\n          mobile\n          whatsApp\n          phone\n          businessPhone\n          isBank\n        }\n      }\n    "], ["\n      query GetProperties($where: UserWhereUniqueInput!) {\n        user(where: $where) {\n          mobile\n          whatsApp\n          phone\n          businessPhone\n          isBank\n        }\n      }\n    "]))),
    };
}
exports.getAuthorNumbersByUserId = getAuthorNumbersByUserId;
function getUserBundleInfo(_a) {
    var id = _a.id;
    return {
        query: (0, graphql_tag_1.default)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["{\n      user(where: {\n        id: \"", "\"\n      }){\n        id\n        remainingListingsCreateCount\n        usedListingsCreateCount\n        }\n      }"], ["{\n      user(where: {\n        id: \"", "\"\n      }){\n        id\n        remainingListingsCreateCount\n        usedListingsCreateCount\n        }\n      }"])), id),
    };
}
exports.getUserBundleInfo = getUserBundleInfo;
function getUserByMobile(_a) {
    var mobile = _a.mobile;
    return {
        query: (0, graphql_tag_1.default)(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["{\n    user(where: {\n      mobile: \"", "\"\n    }){\n      id\n      name\n      mobile\n      mobileVerified\n      isBank\n    }\n  }"], ["{\n    user(where: {\n      mobile: \"", "\"\n    }){\n      id\n      name\n      mobile\n      mobileVerified\n      isBank\n    }\n  }"])), mobile),
    };
}
exports.getUserByMobile = getUserByMobile;
function getUserById(_a) {
    var id = _a.id;
    return {
        query: (0, graphql_tag_1.default)(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["{\n    user(where: {\n      id: \"", "\"\n    }){\n      id\n      name\n      mobile\n      phone\n      whatsApp\n      email\n      about\n      photo\n      company\n      role\n      businessPhone\n      businessAddress\n      googleId\n      facebookId\n      accountType\n      isBank\n      status\n    }\n  }"], ["{\n    user(where: {\n      id: \"", "\"\n    }){\n      id\n      name\n      mobile\n      phone\n      whatsApp\n      email\n      about\n      photo\n      company\n      role\n      businessPhone\n      businessAddress\n      googleId\n      facebookId\n      accountType\n      isBank\n      status\n    }\n  }"])), id),
    };
}
exports.getUserById = getUserById;
function updateUser(_a) {
    var userData = _a.userData, userId = _a.userId, filesObj = _a.filesObj;
    var variables = {
        data: userData,
        where: {
            id: userId,
        },
        files: filesObj,
    };
    return {
        variables: variables,
        mutation: (0, graphql_tag_1.default)(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n      mutation(\n        $data: UserUpdateInput!\n        $where: UserWhereUniqueInput!\n        $files: CreateUserImages\n      ) {\n        updateUser(data: $data, where: $where, files: $files) {\n          id\n          name\n          mobile\n          whatsApp\n          email\n          phone\n          about\n          company\n          role\n          businessPhone\n          businessAddress\n          photo\n          isBank\n        }\n      }\n    "], ["\n      mutation(\n        $data: UserUpdateInput!\n        $where: UserWhereUniqueInput!\n        $files: CreateUserImages\n      ) {\n        updateUser(data: $data, where: $where, files: $files) {\n          id\n          name\n          mobile\n          whatsApp\n          email\n          phone\n          about\n          company\n          role\n          businessPhone\n          businessAddress\n          photo\n          isBank\n        }\n      }\n    "]))),
    };
}
exports.updateUser = updateUser;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
